import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import { useTranslation } from 'react-i18next';


import CookieConsent from "react-cookie-consent";

export default function OthelloCookieConsent({ ...props }) {

    const { t } = useTranslation();

    const { } = props;

   
    return (<CookieConsent location="bottom" cookieName="othelloconsent" expires={999} overlay style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px", background: "#2983eb" }} buttonText="Aceptar">
        {t("_consentimientocookies")}
    </CookieConsent>
    );
}

OthelloCookieConsent.propTypes = {
    
};
